import { render, staticRenderFns } from "./OnboardingLoading.vue?vue&type=template&id=68dd0390"
import script from "./OnboardingLoading.vue?vue&type=script&lang=js"
export * from "./OnboardingLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports